































































import { Component, Vue } from 'vue-property-decorator'
import Plyr from 'plyr'
import { thumbURL } from '../services/cover-service'
import { progress } from '@/services/now'
import { URLs } from '../services/web-services'

@Component({
  props: {
    now: Object
  }
})
export default class BottomPlayer extends Vue {
  expanded = true
  progress = 0
  player!: Plyr
  isOutOfSync = false
  liveStreamURL = URLs.liveStream
  private status: 'playing' | 'paused' | 'stopped' = 'stopped'
  private refreshProgressIntervalHandle!: number

  toggleExpanded () {
    this.expanded = !this.expanded
  }

  coverURL (filename: string): string {
    return thumbURL(filename)
  }

  refreshProgress () {
    if (!this.$props.now) return
    this.progress = progress(this.$props.now)
  }

  play () {
    this.player.play()
  }

  pause () {
    this.player.pause()
  }

  backToLive () {
    this.player.stop()
    this.isOutOfSync = false
    this.player.source = {
      type: 'audio',
      sources: [
        {
          src: this.liveStreamURL,
          type: 'audio/mp3'
        }
      ]
    }
    this.player.play()
  }

  private autoRefreshProgress () {
    this.refreshProgressIntervalHandle = setInterval(() => {
      this.refreshProgress()
    }, 1000)
    if (module.hot) {
      module.hot.dispose(() => {
        clearInterval(this.refreshProgressIntervalHandle)
      })
    }
  }

  private setupPlayer () {
    this.player = new Plyr(this.$refs.player as HTMLElement)
    this.player.on('play', () => {
      this.status = 'playing'
    })
    this.player.on('pause', () => {
      this.status = 'paused'
      this.isOutOfSync = true
    })
    this.player.on('ended', () => {
      console.log('ended')
    })
  }

  mounted () {
    this.setupPlayer()
    this.autoRefreshProgress()
  }

  beforeUnmount () {
    clearInterval(this.refreshProgressIntervalHandle)
  }
}
